module.exports = __webpack_public_path__ + "resources/images/screen2-41842329dc6834fb5b273b11562386b4-cache.png";